module.exports = __webpack_public_path__ + "img/epub.9c580043.jpg";